import React, { useEffect } from 'react'
import Stack from './stack'
import Button from './button'
import Divider from './divider'
import { useNotification } from '../lib/notification'

interface INotificationProps extends React.HTMLProps<HTMLDivElement> {
  title: string
  description: string
  id: string
  autoClose?: boolean
  duration?: number
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error'
}

const Notification: React.FC<INotificationProps> = ({
  title,
  description,
  id,
  autoClose = true,
  duration = 5000,
  variant,
  ...rest
}) => {
  const { deleteNotification } = useNotification()

  useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        // eslint-disable-next-line no-unused-expressions
        document.getElementById('notification-delete-button')?.click()
      }, duration)
    }
  }, [autoClose, duration])

  return (
    <div className={`notification notification-${variant}`} {...rest}>
      <Stack block style={{ justifyContent: 'space-between' }} align='center'>
        <h4>{title}</h4>
        <Button
          variant='link'
          size='small'
          style={{ padding: 0 }}
          id='notification-delete-button'
          onClick={() => deleteNotification(id)}
        >
          Close
        </Button>
      </Stack>
      <Divider spacing='small' />
      <p>{description}</p>
    </div>
  )
}

export default Notification
